// removed by extract-text-webpack-plugin
module.exports = {"container":"_2J5CDZImBNmH6dauAME1Kd","button":"_1d5bj1-oDhyVkK9J_3IBBq","icon1":"_3y4TUo3T_f91xazrAMlJp-","icon2":"_2OTNDQTexDdUkNCJSQrPMz","icon3":"_2IXHLx8pqDKAyJCo-ZSyzV"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Common/styles.css
// module id = 2715
// module chunks = 0